export const LANGUAGE_OPTIONS = [
    { code: 'en', name: 'English' },
    { code: 'ru', name: 'Russian' },
] as const;

export const SUPPORTED_LANGUAGE_CODES = LANGUAGE_OPTIONS.map((language) => language.code);
